import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import srLocale from 'date-fns/locale/sr-Latn';

const useStyles = makeStyles((theme) => ({
	datePicker: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	}
}));

const MuiDatePicker = (props) => {
    const { name, value, onChange, label, placeholder, readOnly, views, disabled, clearable } = props;
    const { datePicker } = useStyles();
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={srLocale}>
            <KeyboardDatePicker
                disabled={disabled}
                name={name}
                label={label}
                placeholder={placeholder}
                className={datePicker}
                clearable={clearable}
                readOnly={readOnly}
                value={value}
                onChange={onChange}
                ampm={false}
                format={views && views.includes('year') ? 'yyyy' : 'dd.MM.yyyy'}
                clearLabel="Obriši"
                cancelLabel="Odustani"
                okLabel="Potvrdi"
                fullWidth
                views={views}
                invalidDateMessage=""
            />
        </MuiPickersUtilsProvider>
    )
};

MuiDatePicker.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    clearable: PropTypes.bool,
    views: PropTypes.array,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
}

export default MuiDatePicker;
